module.exports = __webpack_public_path__ + "static/img/start-icon.f7bb93e.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/NikeWebGL/Pages/Play/img/start/start-icon.png
// module id = 192
// module chunks = 0